import gql from 'graphql-tag';

export const QUERY = gql([
    `
query QueryJeuContents($filter: String!)
{
  queryJeuContents(top: 1, skip: 0, filter: $filter) {
    data {
      pageTitle { iv }
      
      confirmationText { iv }
      confirmationTextColor { iv }

      titleBlocTitle { iv }
      titleBlocSubTitle { iv }
      titleBlocFontSizeTitle { iv }
      titleBlocFontSizeSubTitle { iv }
      titleBlocWidth { iv }
      titleBlocTagline { iv }
      titleBlocTextColor { iv }
      titleBlocColor { iv }
      titleBlocCtaLink { iv }
      titleBlocCtaText { iv }
      titleBlocCtaStyle { iv }
      titleBlocCtaLink2 { iv }
      titleBlocCtaText2 { iv }
      titleBlocCtaStyle2 { iv }
      titleBlocPicture {
        iv {
          url
          fileSize
        }
      }
      titleBlocHorizontalPosition { iv }
      titleBlocVerticalPosition { iv }
      titleBlocJustification { iv }
    }
  }
}
`,
]);
